export default class EventService {
  static emitResultsEvent(
    emit: (event: string, value: number) => any,
    ...results: [any[]]
  ): void {
    let sum = 0;
    results[0].forEach((result) => {
      if (result && result.length) sum += result.length;
    });
    emit('loaded-appointments', sum);
  }

  static emitRequestError(
    emit: (event: string, value: any) => any,
    result: any
  ): void {
    emit('request-error', result);
  }
}
